/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';
import genericReducers from '../genericReducer';
import { IReducers } from '../index';

import { GET_TOURISM_KINDS } from '../../actions/employees';
import { REQUEST, FAILURE, SUCCESS } from '../../actions/utils';

import { ICommonResponse, IDictionaryItem } from '../../api/types';

export type TourismKindsState = ICommonResponse<IDictionaryItem>;

const initialState = {} as ICommonResponse<IDictionaryItem>;
const generic = genericReducers<TourismKindsState>();
const tourismKinds: IReducers<TourismKindsState> = {
  [GET_TOURISM_KINDS[REQUEST]]: generic.get.request,
  [GET_TOURISM_KINDS[SUCCESS]]: generic.get.success,
  [GET_TOURISM_KINDS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, tourismKinds);
